import axios from "axios";
import { useMutation } from "@tanstack/react-query";

import { Keys } from "clients/apis/_keys";
import { Routes } from "clients/apis/_routes";

import { onEditFactorRes } from "./helper";

export const editFactor = async (params: { id: number; data: FactorReqT }) =>
  axios.put(Routes.EDIT_FACTOR + "/" + params.id, { ...params.data });

export const useEditFactor = () =>
  useMutation({
    mutationKey: [Keys.EDIT_FACTOR_MUT],
    mutationFn: editFactor,
    onSuccess: (res) => {
      onEditFactorRes(res);
      return res;
    },
  });
